import clientAPIV3 from '@/clientAPIV3'
import {InvitationAgentAndRepsResponseType, RepresentedHostsType} from '../types'
import {InvitationAgentAndRepsResponseSchema} from './representative.schema'
import {InvitationAgentType} from '@/features/agent/types'

export const sentRepresentativeInvitationV3 = async (dataToSend: InvitationAgentType): Promise<InvitationAgentType> => {
    const {data} = await clientAPIV3.post('/agents/representatives', dataToSend)
    return data
}

export const getRepresentativeDetailsV3 = async (token: string): Promise<InvitationAgentAndRepsResponseType> => {
    const {data} = await clientAPIV3.get(`/representatives/invitations/verify/${token}`)
    return InvitationAgentAndRepsResponseSchema.parse(data)
}

export const deleteRepresentativeV3 = async (id: number) => {
    return await clientAPIV3.delete(`/agents/representatives/${id}`)
}

export const updateRepresentativeV3 = async (id: number, body: {rookiesId?: number[]; modesIds?: number[]}) => {
    return await clientAPIV3.post(`/agents/representatives/${id}`, body)
}

export const representativeAcceptRequestV3 = async (token: string) => {
    return await clientAPIV3.get(`/agents/representatives/requests/accept/${token}`)
}

export const representativeHostsV3 = async (): Promise<RepresentedHostsType[]> => {
    const {data} = await clientAPIV3.get('/representatives/creators')
    return data
}

export const representativeHostsChannelsV3 = async () => {
    const {data} = await clientAPIV3.get('/representatives/creators/channels')
    return data
}
